<!-- Provider Toolkit: Overview table + filters (from mockup-provider-toolkit.html) -->

<div class="ptkOv">
	<div class="filters-bar">

		<select class="filter-select" [(ngModel)]="vm.clientTheme" (ngModelChange)="vm.applyClientFilters()">
			<option value="ALL">{{ 'Toolkit.Provider.Filters.Theme.All' | translate }}</option>
			<option *ngFor="let t of (vm.themes || [])" [value]="t.id">{{ vm.themeName(t.id) | translate }}</option>
		</select>

		<select class="filter-select" [(ngModel)]="vm.clientStatus" (ngModelChange)="vm.applyClientFilters()">
			<option value="ALL">{{ 'Toolkit.Provider.Filters.Status.All' | translate }}</option>
			<option value="ACTIVE">{{ 'Toolkit.Status.Active' | translate }}</option>
			<option value="OVERDUE">{{ 'Toolkit.Status.Overdue' | translate }}</option>
			<option value="DONE">{{ 'Toolkit.Status.Done' | translate }}</option>
			<option value="NEW">{{ 'Toolkit.Status.NewClient' | translate }}</option>
		</select>

		<select class="filter-select" [(ngModel)]="vm.clientToolkitFilter" (ngModelChange)="vm.applyClientFilters()">
			<option value="ALL">{{ 'Toolkit.Provider.Filters.Exercise.All' | translate }}</option>
			<option value="PENDING">{{ 'Toolkit.Provider.Filters.Exercise.Pending' | translate }}</option>
			<option value="COMPLETED">{{ 'Toolkit.Provider.Filters.Exercise.Completed' | translate }}</option>
			<option value="NONE">{{ 'Toolkit.Provider.Filters.Exercise.None' | translate }}</option>
		</select>

		<select class="filter-select" [(ngModel)]="vm.clientSurveyFilter" (ngModelChange)="vm.applyClientFilters()">
			<option value="ALL">{{ 'Toolkit.Provider.Filters.Survey.All' | translate }}</option>
			<option value="PENDING">{{ 'Toolkit.Provider.Filters.Survey.Pending' | translate }}</option>
			<option value="COMPLETED">{{ 'Toolkit.Provider.Filters.Survey.Completed' | translate }}</option>
			<option value="NONE">{{ 'Toolkit.Provider.Filters.Survey.None' | translate }}</option>
		</select>

		<select class="filter-select" [(ngModel)]="vm.clientSort" (ngModelChange)="vm.applyClientFilters()">
			<option value="next_session">{{ 'Toolkit.Provider.Filters.Sort.NextSession' | translate }}</option>
			<option value="name">{{ 'Toolkit.Provider.Filters.Sort.Name' | translate }}</option>
		</select>

		<input
			type="text"
			class="filter-search"
			placeholder="{{ 'Toolkit.Provider.Filters.Search.Placeholder' | translate }}"
			spellcheck="false"
			[(ngModel)]="vm.clientSearch"
			(ngModelChange)="vm.applyClientFilters()">

		<button class="filter-reset" type="button" (click)="vm.resetClientFilters()">{{ 'Toolkit.Provider.Filters.Reset' | translate }}</button>
	</div>

	<div class="table-wrap">
		<table class="roster-table">
			<thead>
				<tr>
					<th>{{ 'Toolkit.Provider.Overview.Table.Client' | translate }}</th>
					<th>{{ 'Toolkit.Provider.Overview.Table.NextSession' | translate }}</th>
					<th>{{ 'Toolkit.Format.Exercise' | translate }}</th>
					<th>{{ 'Toolkit.Provider.Overview.Table.Surveys' | translate }}</th>
					<th>{{ 'Toolkit.Provider.Overview.Table.Status' | translate }}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let c of (vm.filteredClientsOverview || [])" class="click-row" (click)="vm.openClientRoute(c)">
					<ng-container *ngIf="vm.getClientSummary(c) as s">
						<td [attr.data-label]="'Toolkit.Provider.Overview.Table.Client' | translate">
							<div class="name-cell">
								<div class="avatar-sm">{{ vm.initials(c) }}</div>
								<div class="name-text">
									{{ c.firstname }} {{ c.lastname }}
									<span class="sub" *ngIf="c.themeKeys?.length">
										<ng-container *ngFor="let t of c.themeKeys; let last = last">
											{{ t | translate }}<span *ngIf="!last"> · </span>
										</ng-container>
									</span>
								</div>
							</div>
						</td>
						<td class="next-cell" [attr.data-label]="'Toolkit.Provider.Overview.Table.NextSession' | translate"><strong>{{ c.nextSessionText || '-' }}</strong></td>
						<td [attr.data-label]="'Toolkit.Format.Exercise' | translate">
							<div class="progress-cell">
								<div class="progress-track"><div class="progress-fill" [ngClass]="progressFillClass(s.toolsCompleted, s.toolsTotal)" [style.width.%]="progressPercent(s.toolsCompleted, s.toolsTotal)"></div></div>
								<span class="progress-text">{{ s.toolsCompleted }} / {{ s.toolsTotal }}</span>
							</div>
						</td>
						<td [attr.data-label]="'Toolkit.Provider.Overview.Table.Surveys' | translate">
							<div class="progress-cell">
								<div class="progress-track"><div class="progress-fill" [ngClass]="progressFillClass(s.surveysCompleted, s.surveysTotal)" [style.width.%]="progressPercent(s.surveysCompleted, s.surveysTotal)"></div></div>
								<span class="progress-text">{{ s.surveysCompleted }} / {{ s.surveysTotal }}</span>
							</div>
						</td>
						<td [attr.data-label]="'Toolkit.Provider.Overview.Table.Status' | translate">
							<span class="status-pill" [ngClass]="statusPill(s).cls">
								<span class="pill-dot"></span>
								<span>{{ statusPill(s).key | translate }}</span>
								<span *ngIf="statusPill(s).count && statusPill(s).count > 0 && statusPill(s).cls === 'pill-overdue'">({{ statusPill(s).count }})</span>
							</span>
						</td>
						<td [attr.data-label]="'Toolkit.Common.Open' | translate">
							<div class="row-actions" (click)="$event.stopPropagation()">
								<button class="icon-btn" [title]="'Toolkit.Common.Open' | translate" type="button" (click)="vm.openClientRoute(c)">
									<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
								</button>
							</div>
						</td>
					</ng-container>
				</tr>

				<tr *ngIf="!(vm.filteredClientsOverview || []).length">
					<td colspan="6" class="empty-cell">{{ 'Toolkit.Clients.Empty' | translate }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
